import script from "./ShipLogsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipLogsView.vue?vue&type=script&setup=true&lang=js"

import "./ShipLogsView.vue?vue&type=style&index=0&id=5fdfafb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fdfafb0"]])

export default __exports__